const GRAPHS_COLUMNS = [
  {
    field: "title",
    headerName: "Titull",
    width: 400,
    minWidth: 400,
    flex: 1,
    editable: false,
  },
  {
    field: "year",
    headerName: "Viti",
    width: 80,
    maxWidth: 80,
    minWidth: 80,
    flex: 1,
    editable: false,
  },
];

export default GRAPHS_COLUMNS;
